/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import TextField from 'components/TextField';
import Paper from '@material-ui/core/Paper';
import Image from 'components/Image';
import Button from 'components/Button';
import { useDispatch } from 'react-redux';
import {
  getStaplesDesigns,
  clearStaplesArtwork,
  searchDesigns,
} from 'actions/designer';
import useStaplesArtFiles from 'pages/staples-art-files/context';
import {
  Body,
  Pagination,
  Arts,
  Art,
  StyledDeleteIcon,
  NoDataFound,
  FileName,
  FileFormat,
  SearchBar,
  SearchTextbox,
  SearchBarButtons,
  ArtFile,
} from 'styles/pages/staples-art-files';

const ArtFiles = ({
  resourceType,
  deleteArtFile,
  onSelect,
  searching,
  searchDefaultValue,
}) => {
  const dispatch = useDispatch();
  const [search, setSearch] = useState('');
  const { value, setValue } = useStaplesArtFiles();

  const fetchStaplesDesigns = async () => {
    const response = await dispatch(
      getStaplesDesigns({ resource_type: resourceType })
    );
    setValue(response);
  };

  useEffect(() => {
    if (!value) {
      fetchStaplesDesigns();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value, dispatch]);

  // useEffect(async () => {
  //   if (!search) {
  //     setSearch(`PO-${searchDefaultValue}`);
  //   }
  // }, [searchDefaultValue, search]);

  return (
    <Body>
      {searching && (
        <SearchBar>
          <SearchTextbox>
            <TextField
              label="Search Art File"
              size="small"
              value={search}
              onChange={(v) => setSearch(v)}
              onKeyDown={async (e) => {
                if (e.keyCode === 13 && !!search?.trim()?.length) {
                  const payload = { searchString: search };
                  const response = await dispatch(searchDesigns(payload));
                  setValue(response);
                }
              }}
            />
          </SearchTextbox>
          <SearchBarButtons>
            <Button
              title="Search"
              disabled={!search}
              onClick={async () => {
                const payload = { searchString: search };
                const response = await dispatch(searchDesigns(payload));
                setValue(response);
              }}
            />
            <Button
              title="Clear"
              disabled={!search}
              onClick={() => {
                setSearch('');
                fetchStaplesDesigns();
              }}
            />
          </SearchBarButtons>
        </SearchBar>
      )}
      <Pagination>
        <Button
          title="Prev"
          disabled={!value?.prevCursors?.length}
          onClick={async () => {
            const prevCursors = value?.prevCursors;
            const response = await dispatch(
              getStaplesDesigns({
                resource_type: resourceType,
                next_cursor:
                  prevCursors?.length === 1
                    ? undefined
                    : prevCursors[prevCursors?.length - 1],
              })
            );

            prevCursors.pop();

            setValue(() => ({
              ...value,
              resources: response?.resources,
              next_cursor: response?.next_cursor,
              prevCursors,
            }));
          }}
        />
        <Button
          title="Next"
          disabled={!value?.next_cursor}
          onClick={async () => {
            const nextCursor = value?.next_cursor;

            const response = await dispatch(
              getStaplesDesigns({
                next_cursor: nextCursor,
                resource_type: resourceType,
              })
            );

            const prevCursors = value?.prevCursors
              ? [...value.prevCursors, value?.prev_cursor]
              : [undefined];

            setValue(() => ({
              ...value,
              resources: response?.resources,
              prev_cursor: nextCursor,
              next_cursor: response?.next_cursor,
              prevCursors,
            }));
          }}
        />
      </Pagination>
      {!!value?.resources?.length && (
        <Arts>
          {value?.resources?.map((r) => (
            <Paper
              key={r?.asset_id}
              style={{ border: '1px solid #ccc', marginBottom: 20 }}
            >
              <Art
                style={{
                  cursor: _.isFunction(onSelect) ? 'pointer' : 'default',
                }}
                onClick={() => {
                  if (_.isFunction(onSelect)) onSelect(r);
                }}
              >
                {deleteArtFile && (
                  <StyledDeleteIcon
                    onClick={async () => {
                      const payload = {
                        publicId: r?.public_id,
                        resource_type: resourceType,
                      };
                      await dispatch(clearStaplesArtwork(payload));
                      setValue(undefined);
                    }}
                  />
                )}
                <ArtFile>
                  <div className="src">
                    <img src={r?.secure_url} alt="staples-art" />
                  </div>
                </ArtFile>

                <FileName>
                  {r?.public_id?.split('/')[1]?.split('.')[0]}
                </FileName>
                <FileFormat>
                  {resourceType === 'raw' ? 'DST' : r?.format}
                </FileFormat>
              </Art>
            </Paper>
          ))}
        </Arts>
      )}

      {!value?.resources?.length && <NoDataFound>No Data Found !</NoDataFound>}
    </Body>
  );
};

export default ArtFiles;
